/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { singularize } from '@linc-technologies/linced-common/utils/inflector';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class AttendanceReportChart extends Component {
  height = 150;
  width = 150;
  thickness = 32;
  showLabel = true;
  @tracked showPlaceholder = false;

  @computed(
    'term.{present,late,justified,unjustified}',
    'periods',
    'showPlaceholder',
  )
  get chartData() {
    let slices = [];
    let present = this.get('term.present') ?? 0;
    let late = this.get('term.late') ?? 0;
    let justified = this.get('term.justified') ?? 0;
    let unjustified = this.get('term.unjustified') ?? 0;
    let periods = this.periods;
    let period = singularize(periods);
    if (present > 0) {
      slices.push({
        value: 'Present',
        count: present,
        tooltip: `Present: ${present} ${present === 1 ? period : periods}`,
        color: '#4CAF50',
      });
    }
    if (late > 0) {
      slices.push({
        value: 'Late',
        count: late,
        tooltip: `Late: ${late} ${late === 1 ? period : periods}`,
        color: '#8BC34A',
      });
    }
    if (justified > 0) {
      slices.push({
        value: 'Justified',
        count: justified,
        tooltip: `Justified Absence: ${justified} ${
          justified === 1 ? period : periods
        }`,
        color: '#FF9800',
      });
    }
    if (unjustified > 0) {
      slices.push({
        value: 'Unjustified',
        count: unjustified,
        tooltip: `Unjustified Absence: ${unjustified} ${
          unjustified === 1 ? period : periods
        }`,
        color: '#EF5350',
      });
    }

    if (isEmpty(slices) && this.showPlaceholder) {
      slices.push({
        value: 'No data',
        count: 1,
        tooltip: 'No data',
        color: '#bdbdbd',
      });
    }

    return slices;
  }
}
